export const FETCH_RESOURCES = 'FETCH_RESOURCES';
export const UPDATE_RESOURCES = 'UPDATE_RESOURCES';
export const FETCH_ELEMENT_INFO = 'FETCH_ELEMENT_INFO';
export const UPDATE_ELEMENT = 'UPDATE_ELEMENT';
export const FETCH_APPS = 'FETCH_APPS';
export const UPDATE_APPS = 'UPDATE_APPS';
export const RESET_ELEMENT = 'RESET_ELEMENT';
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const CREATE_PATTERN = 'CREATE_PATTERN';
export const DELETE_PATTERN = 'DELETE_PATTERN';
export const CREATE_ELEMENT = 'CREATE_ELEMENT';
export const DELETE_ELEMENT = 'DELETE_ELEMENT';
export const UPDATE_ELEMENT_INFO = 'UPDATE_ELEMENT_INFO';
export const RESET_RESOURCES = 'RESET_RESOURCES';
export const FETCH_PARTNERS = 'FETCH_PARTNERS';
export const UPDATE_PARTNERS = 'UPDATE_PARTNERS';
